/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserContactRequest
 */
export interface CreateUserContactRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserContactRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserContactRequest
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserContactRequest
     */
    cellPhone: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserContactRequest
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserContactRequest
     */
    sendRoboDials: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserContactRequest
     */
    sendRoboTexts: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserContactRequest
     */
    sendEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserContactRequest
     */
    sendStatements: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUserContactRequest
     */
    addressLine1?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserContactRequest
     */
    addressLine2?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserContactRequest
     */
    addressLine3?: string | null;
}

/**
 * Check if a given object implements the CreateUserContactRequest interface.
 */
export function instanceOfCreateUserContactRequest(value: object): value is CreateUserContactRequest {
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('cellPhone' in value) || value['cellPhone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('sendRoboDials' in value) || value['sendRoboDials'] === undefined) return false;
    if (!('sendRoboTexts' in value) || value['sendRoboTexts'] === undefined) return false;
    if (!('sendEmail' in value) || value['sendEmail'] === undefined) return false;
    if (!('sendStatements' in value) || value['sendStatements'] === undefined) return false;
    return true;
}

export function CreateUserContactRequestFromJSON(json: any): CreateUserContactRequest {
    return CreateUserContactRequestFromJSONTyped(json, false);
}

export function CreateUserContactRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserContactRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'cellPhone': json['cellPhone'],
        'email': json['email'],
        'sendRoboDials': json['sendRoboDials'],
        'sendRoboTexts': json['sendRoboTexts'],
        'sendEmail': json['sendEmail'],
        'sendStatements': json['sendStatements'],
        'addressLine1': json['addressLine1'] == null ? undefined : json['addressLine1'],
        'addressLine2': json['addressLine2'] == null ? undefined : json['addressLine2'],
        'addressLine3': json['addressLine3'] == null ? undefined : json['addressLine3'],
    };
}

export function CreateUserContactRequestToJSON(json: any): CreateUserContactRequest {
    return CreateUserContactRequestToJSONTyped(json, false);
}

export function CreateUserContactRequestToJSONTyped(value?: CreateUserContactRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'cellPhone': value['cellPhone'],
        'email': value['email'],
        'sendRoboDials': value['sendRoboDials'],
        'sendRoboTexts': value['sendRoboTexts'],
        'sendEmail': value['sendEmail'],
        'sendStatements': value['sendStatements'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
    };
}

